package com.milta.core.localization.translations.sq

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Duke ngarkuar…",
    errorNoConnection = "Nuk mund të kontaktohet serveri — kontrollo lidhjen tënde.",
    errorGeneric = "Ndodhi një gabim. Provo përsëri më vonë.",
    emptyStateMessage = "Ende pa të dhëna.",
    kpiTotalDocumentsLabel = "Dokumente të analizuara",
    kpiCompletedDocumentsLabel = "Dokumente të plota",
    kpiCompletedDocumentsSubtitle = "të simuluara për 4 strategjitë",
    kpiTotalRealCostLabel = "Kosto reale totale",
    kpiTotalInputTokensLabel = "Token hyrje",
    kpiTotalOutputTokensLabel = "Token dalje",
    breakdownByFileKindLabel = "Ndarje",
    fileKindImageLabel = "Imazhe",
    fileKindPdfLabel = "PDF",
    fileKindXlsxLabel = "Fletëllogaritëse",
    flowTitle = "Rrjedha e plotë, hap pas hapi",
    flowYesLabel = "Po",
    flowNoLabel = "Jo",
    flowStep1Title = "Dokument i dërguar",
    flowStep1Subtitle = "Foto, PDF ose skedar i marrë përmes aplikacionit",
    flowStep2Title = "Gjurmë unike e llogaritur",
    flowStep2Subtitle = "Llogaritet një identifikues unik për këtë dokument",
    flowStep2Note = "Nëse është parë tashmë: analiza lokale nuk ribëhet (kostoja reale e IA numërohet gjithsesi normalisht, pasi është një ngarkim real).",
    flowStep3Title = "Lloji i skedarit u zbulua",
    flowStep3Subtitle = "Pjesa tjetër e analizës ndryshon sipas llojit",
    flowImageBranchTitle = "📷 Nëse është foto",
    flowImageStep1Title = "Kontroll i cilësisë",
    flowImageStep1Subtitle = "Qartësia, ndriçimi, rezolucioni, dokument i kuadruar mirë",
    flowImageStep2Title = "Nëse cilësia gjykohet e pamjaftueshme",
    flowImageStep2Subtitle = "Arsyeja regjistrohet, por leximi lokal provohet gjithsesi menjëherë pas",
    flowImageStep3Title = "Korrigjim i pjerrësisë",
    flowImageStep3Subtitle = "Imazhi drejtohet nëse zbulohet një pjerrësi e besueshme",
    flowImageStep4Title = "Lexim lokal (falas)",
    flowImageStep4Subtitle = "Lexim i tekstit pa IA — frëngjisht, holandisht, anglisht",
    flowImageStep5Title = "Vlerësim besueshmërie",
    flowImageStep5Subtitle = "Vlerësim nga 0 deri në 100 mbi cilësinë e këtij leximi lokal",
    flowPdfBranchTitle = "📄 Nëse është PDF",
    flowPdfStep1Title = "A u zbulua tekst nativ?",
    flowPdfStep1Subtitle = "Kontrollon nëse PDF-ja përmban tashmë tekst dixhital të përdorshëm",
    flowPdfNote = "Nëse është skanuar pa tekst nativ: çdo faqe (deri në 20) shndërrohet në imazh dhe rilexohet lokalisht, njësoj si një foto.",
    flowXlsxBranchTitle = "📊 Nëse është fletëllogaritëse",
    flowXlsxStep1Title = "Kolonat u identifikuan",
    flowXlsxStep1Subtitle = "Njohje automatike, ose me ndihmën e IA, e kolonave (emri, adresa, telefoni…)",
    flowXlsxNote = "Struktura e skedarit (rreshta, kolona, kryerresht) analizohet lokalisht.",
    flowClaudeTitle = "Thirrje drejt IA (Claude)",
    flowClaudeSubtitle = "Sot bëhet gjithmonë një thirrje reale, pavarësisht rrugës më sipër — kosto reale e faturuar",
    flowSimulationTitle = "🔬 Simulim pas ngjarjes (jo në prodhim)",
    flowSimulationNote = "Pasi të dhënat më sipër të jenë mbledhur, 4 strategji alternative riluhen mbi të njëjtat dokumente për të vlerësuar sa do të kushtonin në vend të thirrjes sistematike drejt IA — kjo është saktësisht ajo që krahason tabela më poshtë. Asnjëra nga këto 4 strategji nuk përdoret aktualisht në prodhim.",
    flowPersistTitle = "U ruajt",
    flowPersistSubtitle = "Rezultati real dhe 4 simulimet ruhen",
    flowDashboardTitle = "Paneli",
    flowDashboardSubtitle = "Ky ekran mbledh rezultatet sipas strategjisë",
    tableTitle = "Krahasimi i strategjive të mundshme",
    columnMode = "Strategjia",
    columnDocuments = "Dokumente",
    columnClaudeCalls = "Thirrje drejt IA",
    columnProjectedCost = "Kosto e parashikuar",
    columnRealCost = "Kosto reale",
    columnSavings = "Kursim i parashikuar",
    modeBaseline = "Strategjia aktuale",
    modeBaselineDescription = "IA thirret sistematikisht për çdo dokument — kjo është ajo që përdoret realisht sot në prodhim.",
    modeMinimal = "Para-përpunim i lehtë",
    modeMinimalDescription = "Optimizime të vogla para dërgimit te IA, pa ndryshuar vendimin: IA thirret gjithmonë, e njëjta kosto si strategjia aktuale.",
    modeTesseractGate = "Lexim lokal me rikthim te IA",
    modeTesseractGateDescription = "Një lexim lokal falas vlerëson fillimisht cilësinë e dokumentit; IA thirret vetëm nëse ky lexim gjykohet i pamjaftueshëm.",
    modeTesseractOnly = "Vetëm lexim lokal",
    modeTesseractOnlyDescription = "Asnjë thirrje drejt IA — vetëm një lexim lokal falas, potencialisht më pak i besueshëm në dokumente me cilësi të dobët.",
)
